import Polynomial from "../util/Polynomial.js";

export default class RegressionApiClient {
	#httpClient;
	#endpointUrl;

	constructor(httpClient, endpointUrl = '/api/stats') {
		this.#httpClient = httpClient;
		this.#endpointUrl = endpointUrl;
	}

	/**
	 * @param {{x:number[], y:number[]}} request
	 * @returns {Promise<{polynomial: Polynomial, r2: number}>}
	 */
	async getPolynomialRegression(request) {
		const response = await this.#httpClient
			.fetch(`${this.#endpointUrl}/curve`, {
				method: 'PUT',
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify(request),
				responseType: 'json'
			});
		return {polynomial: new Polynomial(response.polynomial), r2: response.r2};
	}
}
